module.exports = __webpack_public_path__ + "img/caseai3.b63c11f2.png";